import { schema, normalize } from 'normalizr';

export const entity = 'vendorReturnItemReason';
export const endpoints = {
  listAll: () => ({
    url: '/admin/vendor-returns/reasons/all',
    entity,
    list: true,
  }),
};
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'vendorReturnItemReasonID',
  }
);
export const normalizer = result => normalize(result, entitySchema);
export const listNormalizer = result => normalize(result, [entitySchema]);
